import React from 'react';

export const SecondaryButtonWithIcon = ({label, icon, handleClick}) => {
  return (
    <button className="btn btn-block btn-pill btn-secondary" onClick={handleClick}>
      <span>{label}</span>
      <span className={`icon icon-${icon}`}></span>
    </button>
  );
};